import { environment } from "../../environments/environment";

export interface EnvDescriptor {
  envType: string;
  boGestionUrl: string;
  qdmApiUrl: string;
  qdmApiKey: string;
  title: string;
  buildDate?: string;
  lastPipeline?: string;
}

export class EnvLoader {
  private static isLoaded = false;

  static load(): EnvDescriptor {
    return environment;
  }
}
